import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Spin } from "antd";
// REDUX
import { useSelector } from "react-redux";
import { usePostCarServiceStatisticsMutation } from "../../../redux/reports/reportsAPI";
import useAllBanksMutation from "../useAllBanksMutation";
// COMPONENTS
import ReportsTable from "../ReportsTable";
import ReportsHeader from "../ReportsHeader";
// AUTHORIZATION
import { useScreenPermission } from "../../../customHooks/useScopedPermission";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const ReportCarServiceLog = () => {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [loadPage, setLoadPage] = useState(false);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);
  const { filters } = useSelector((state: RootState) => state.report);
  // Reads SCREEN_PERMISSION["car-service-report-statistics"] -- the same
  // declaration Layout.tsx's sidebar link reads.
  const allowed = useScreenPermission("car-service-report-statistics");

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [triggerGetReport, { data, isLoading, isError, error }] = useAllBanksMutation(
    usePostCarServiceStatisticsMutation(),
    "rows",
  );

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const generateTableRequestBody = ({ downloadReport }: any) => {
    const body = {
      bank_id: filters.bankId,
      start_date: filters.startDate,
      end_date: filters.endDate,
      timezone: filters.timezoneCode,
      download: downloadReport,
    };
    return body;
  };

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    setLoadPage(true);
    setTimeout(() => {
      setLoadPage(false);
    }, 1000);
  }, []);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Spin spinning={loadPage}>
      {allowed ? (
        <div className={`layout__contentPage__${theme}`}>
          <ReportsHeader
            reportDefaultData={{
              reportType: "REPORT",
              levelTypeName: "BANKS",
              allowAllBanks: true,
              displaySelectTypeLevel: false,
              liftType: "ALL",
              defaultColumns: ["mode"],
              defaultOffsets: [],
              infoDescriptionText: "report.infoDescriptionText2",
              displayDownloadCSVReport: true,
              displayDownloadPDFReport: true,
              reportTitle: "Car Service / Statistics",
              displayAdvanceFiltersExclusions: false,
              displayAdvanceFiltersOffsets: false,
              disabledOffsets: true,
              useTablePagination: true,
              displayDateByRange: false,
              displayDate: true,
              displaySelectLiftType: true,
              displayAdvanceFilterCharts: false,
              displayAdvanceFiltersTable: false,
              displayRecentWeeksPicket: false,
              displayInputLimitItems: false,
              displayChartMirror: false,
              chartMirror: false,
              chartType: "bar_stack_vertical",
              dateTypeOptions: [
                { id: "TODAY", name: "Day" },
                { id: "WEEK", name: "Week" },
                { id: "MONTH", name: "Month" },
                { id: "QUARTER", name: "Quarter" },
                { id: "YEAR", name: "Year" },
              ],
              dateDaysLimit: 0,
              displayMinimumActivation: false,
              dateWeeksLimit: 0,
              dateMonthsLimit: 0,
              dateQuarterLimit: 0,
              dateYearsLimit: 0,
              dateType: "MONTH",
              bankSearchAndFilterString: "",
            }}
          />
          <ReportsTable
            response={data}
            generateTableRequestBody={generateTableRequestBody}
            csvUrl={`${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/reports/service/statistics`}
            displayExpandibleRowTable={false}
            groupColumns={null}
            triggerGetReport={triggerGetReport}
            isLoading={isLoading}
            isError={isError}
            error={error}
            isDefaultPaginationReport
          />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </Spin>
  );
};

export default ReportCarServiceLog;
